import { LooseObject } from "../../../loose-object.model";

export enum DisplayOptionStatus {
  UNCHECKED = 'unchecked',
  INDETERMINATE = 'indeterminate',
  CHECKED = 'checked'
}

export enum DisplayOptionType {
  UNDEFINED = 'undefined',
  MIXED = 'mixed',
  VALUE_UNIT = 'value_unit',
  YEARLY = 'yearly'
}

export enum DisplayOptionSource {
  UNDEFINED = 'undefined',
  RESULT = 'result',
  INPUT = 'input'
}

export class DisplayOption {

  label?: string;
  name?: string;
  parent?: DisplayOption;
  children: DisplayOption[];
  status: string; // unchecked, indeterminate, checked
  hidden: boolean;
  depth?: number;
  result?: Object;
  type?: string; // undefined, mixed, value_unit, yearly
  isLeaf?: boolean;
  filterMatched: boolean;
  source?: string; // undefined, result, input

  constructor(label?: string, name?: string, parent?: DisplayOption, depth?: number, result?: Object, isLeaf?: boolean, source?: string) {
    this.label = label;
    this.name = name;
    this.parent = parent;
    this.children = [];
    this.status = 'unchecked';
    this.hidden = false;
    this.depth = depth;
    this.result = result;
    this.type = undefined;
    this.isLeaf = isLeaf;
    this.filterMatched = false;
    this.source = source;
  }

  getName() {
    let name = '';
    if (this.parent) {
      name += this.parent.name;
    }
    name += this.name;
    return name;
  }

  makeChild(label?: string, name?: string, childObject?: LooseObject, isLeaf?: boolean, source?: string): DisplayOption {
    const newDepth = (this.depth ?? 0) + 1;
    const childOption = new DisplayOption(label, name, this, newDepth, childObject, isLeaf, source);
    this.children.push(childOption);
    if (childObject) {
      childObject['aux.DisplayOption'] = childOption;
    }
    return childOption;
  }

  setStatus(status: string) {
    this.setStatusRecursively(status);
    let parent = this.parent;
    while (parent) {
      const statusesSet = new Set(parent.children.map(option => option.status));
      if (statusesSet.has('indeterminate')
        || (statusesSet.has('checked') && statusesSet.has('unchecked'))) {
        parent.status = 'indeterminate';
      } else if (statusesSet.has('checked')) {
        parent.status = 'checked';
      } else {
        parent.status = 'unchecked';
      }
      parent = parent.parent;
    }
  }

  setStatusRecursively(status: string) {
    this.status = status;
    for (const child of this.children) {
      child.setStatusRecursively(status);
    }
  }
}
